import { ReactNode } from 'react';

import { createPortal } from 'react-dom';

import useBrowser from '@/common/hooks/useBrowser/useBrowser';

export interface ModalProps {
  children: ReactNode;
  modalContainerId: string;
}

export const Modal = ({ children, modalContainerId }: ModalProps) => {
  const isBrowser = useBrowser();

  const getModalWrapper = () => {
    let wrapper = document.getElementById(modalContainerId);

    if (!wrapper) {
      wrapper = document.createElement('div');
      wrapper.setAttribute('id', modalContainerId);
      wrapper.setAttribute('data-testid', modalContainerId);
      document.body.appendChild(wrapper);
    }

    return wrapper;
  };
  return isBrowser ? createPortal(children, getModalWrapper()) : null;
};
